import { RESULTS_MODAL_WIDTH } from '@atlassian/jira-servicedesk-cmdb-async-actions-results-modal/src/common/constants.tsx';

export const cmdbAsyncActionsResultsEntrypointModalProps = { width: RESULTS_MODAL_WIDTH };
